var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { confirmDialog } from 'primereact/confirmdialog';
import { MultiSelect } from 'primereact/multiselect';
import { Skeleton } from 'primereact/skeleton';
import { apiService } from '../utils/api';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import '../styles/masterListView.css';
var SKELETON_ROW_COUNT = 8;
var Village = function () {
    var _a;
    var _b = useState([]), villages = _b[0], setVillages = _b[1];
    var _c = useState(null), selectedVillage = _c[0], setSelectedVillage = _c[1];
    var _d = useState(false), dialogVisible = _d[0], setDialogVisible = _d[1];
    var _e = useState(false), viewDialogVisible = _e[0], setViewDialogVisible = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var _g = useState({
        name: '',
        nameTamil: '',
        isActive: true
    }), newVillage = _g[0], setNewVillage = _g[1];
    var _h = useState(''), searchInput = _h[0], setSearchInput = _h[1];
    var _j = useState(''), globalFilter = _j[0], setGlobalFilter = _j[1];
    var _k = useState([]), selectedRows = _k[0], setSelectedRows = _k[1];
    var _l = useState(0), first = _l[0], setFirst = _l[1];
    var _m = useState(12), rows = _m[0], setRows = _m[1];
    var _o = useState(['sno', 'name', 'nameTamil']), visibleColumns = _o[0], setVisibleColumns = _o[1];
    var allColumns = [
        { field: 'sno', header: 'S.No' },
        { field: 'name', header: 'Name' },
        { field: 'nameTamil', header: 'Name (Tamil)' },
    ];
    var toast = useRef(null);
    useEffect(function () {
        fetchVillages();
    }, []);
    useEffect(function () {
        var debounce = setTimeout(function () { return setGlobalFilter(searchInput); }, 300);
        return function () { return clearTimeout(debounce); };
    }, [searchInput]);
    useEffect(function () {
        setFirst(0);
    }, [globalFilter]);
    var fetchVillages = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, apiService.get('/villages')];
                case 2:
                    response = _c.sent();
                    if (response.success) {
                        setVillages(response.data || []);
                    }
                    else {
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to fetch villages' });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _c.sent();
                    console.error('Error fetching villages:', error_1);
                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch villages' });
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentVillage, response, error_2;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    currentVillage = selectedVillage || newVillage;
                    if (!currentVillage.name || !currentVillage.name.trim()) {
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'error', summary: 'Validation Error', detail: 'Name is required' });
                        return [2 /*return*/];
                    }
                    if (!currentVillage.nameTamil || !currentVillage.nameTamil.trim()) {
                        (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Validation Error', detail: 'Name (Tamil) is required' });
                        return [2 /*return*/];
                    }
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 6, , 7]);
                    response = void 0;
                    if (!selectedVillage) return [3 /*break*/, 3];
                    return [4 /*yield*/, apiService.put("/villages/".concat(selectedVillage.id), selectedVillage)];
                case 2:
                    response = _f.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, apiService.post('/villages', newVillage)];
                case 4:
                    response = _f.sent();
                    _f.label = 5;
                case 5:
                    if (response.success) {
                        (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'success', summary: 'Success', detail: "Village ".concat(selectedVillage ? 'updated' : 'saved', " successfully!") });
                        setDialogVisible(false);
                        fetchVillages();
                        resetForm();
                    }
                    else {
                        (_d = toast.current) === null || _d === void 0 ? void 0 : _d.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to save village' });
                    }
                    return [3 /*break*/, 7];
                case 6:
                    error_2 = _f.sent();
                    console.error('Error saving village:', error_2);
                    (_e = toast.current) === null || _e === void 0 ? void 0 : _e.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while saving' });
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            confirmDialog({
                message: 'Are you sure you want to delete this village? This cannot be undone.',
                header: 'Delete Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var response, error_3;
                    var _a, _b, _c;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, apiService.delete("/villages/".concat(id))];
                            case 1:
                                response = _d.sent();
                                if (response.success) {
                                    (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'success', summary: 'Success', detail: 'Village deleted successfully!' });
                                    setSelectedRows(function (prev) { return prev.filter(function (v) { return v.id !== id; }); });
                                    fetchVillages();
                                }
                                else {
                                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to delete village' });
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                error_3 = _d.sent();
                                (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while deleting' });
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }
            });
            return [2 /*return*/];
        });
    }); };
    var handleBulkDelete = function () {
        var count = selectedRows.length;
        confirmDialog({
            message: "Delete ".concat(count, " selected village").concat(count > 1 ? 's' : '', "? This cannot be undone."),
            header: 'Delete Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                var results, failed, error_4;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, Promise.all(selectedRows.map(function (v) { return apiService.delete("/villages/".concat(v.id)); }))];
                        case 1:
                            results = _d.sent();
                            failed = results.filter(function (r) { return !r.success; }).length;
                            if (failed > 0) {
                                (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'warn', summary: 'Partial failure', detail: "".concat(count - failed, " of ").concat(count, " deleted; ").concat(failed, " failed.") });
                            }
                            else {
                                (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'success', summary: 'Success', detail: "".concat(count, " village").concat(count > 1 ? 's' : '', " deleted successfully!") });
                            }
                            setSelectedRows([]);
                            fetchVillages();
                            return [3 /*break*/, 3];
                        case 2:
                            error_4 = _d.sent();
                            (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while deleting the selected villages' });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); }
        });
    };
    var handleView = function (rowData) {
        setSelectedVillage(rowData);
        setViewDialogVisible(true);
    };
    var resetForm = function () {
        setSelectedVillage(null);
        setNewVillage({
            name: '',
            nameTamil: '',
            isActive: true
        });
    };
    var actionBodyTemplate = function (rowData) {
        if (loading)
            return null;
        return (_jsxs("div", __assign({ className: "mdl-action-group" }, { children: [_jsx("button", __assign({ type: "button", className: "mdl-icon-btn", onClick: function () { return handleView(rowData); }, "aria-label": "View village", title: "View Details" }, { children: _jsx("i", { className: "pi pi-eye" }) })), _jsx("button", __assign({ type: "button", className: "mdl-icon-btn", onClick: function () { setSelectedVillage(rowData); setDialogVisible(true); }, "aria-label": "Edit village", title: "Edit" }, { children: _jsx("i", { className: "pi pi-pencil" }) })), _jsx("button", __assign({ type: "button", className: "mdl-icon-btn danger", onClick: function () { return handleDelete(rowData.id); }, "aria-label": "Delete village", title: "Delete" }, { children: _jsx("i", { className: "pi pi-trash" }) }))] })));
    };
    var serialNumberTemplate = function (rowData, options) {
        if (loading)
            return _jsx(Skeleton, { width: "2rem" });
        return options.rowIndex + 1;
    };
    var nameBodyTemplate = function (rowData) {
        if (loading)
            return _jsx(Skeleton, { width: "70%" });
        return _jsx("span", __assign({ className: "mdl-name-cell" }, { children: rowData.name }));
    };
    var nameTamilBodyTemplate = function (rowData) {
        if (loading)
            return _jsx(Skeleton, { width: "70%" });
        return rowData.nameTamil;
    };
    var filteredVillages = villages.filter(function (v) {
        var term = globalFilter.trim().toLowerCase();
        return !term ||
            v.name.toLowerCase().includes(term) ||
            v.nameTamil.toLowerCase().includes(term);
    });
    var handleExport = function () {
        var exportData = filteredVillages.map(function (v, idx) { return ({
            'S.No': idx + 1,
            'Name': v.name,
            'Name (Tamil)': v.nameTamil,
        }); });
        var ws = XLSX.utils.json_to_sheet(exportData);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Villages');
        var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'villages.xlsx');
    };
    var tableValue = loading
        ? Array.from({ length: SKELETON_ROW_COUNT }, function (_, i) { return ({ id: -(i + 1) }); })
        : filteredVillages;
    return (_jsxs("div", __assign({ className: "card mdl-page" }, { children: [_jsx(Toast, { ref: toast }), _jsxs("div", __assign({ className: "mdl-page-header" }, { children: [_jsxs("div", { children: [_jsx("h1", __assign({ className: "mdl-page-title" }, { children: "Village Management" })), _jsxs("p", __assign({ className: "mdl-page-subtitle" }, { children: [villages.length, " village", villages.length === 1 ? '' : 's'] }))] }), _jsxs("div", __assign({ className: "mdl-page-actions" }, { children: [_jsx(Button, { label: "Export", icon: "pi pi-file-excel", className: "mdl-btn-outline", onClick: handleExport }), _jsx(Button, { label: "Add Village", icon: "pi pi-plus", className: "mdl-btn-primary", onClick: function () {
                                    resetForm();
                                    setDialogVisible(true);
                                } })] }))] })), _jsx("div", __assign({ className: "mdl-toolbar" }, { children: selectedRows.length > 0 ? (_jsxs("div", __assign({ className: "mdl-toolbar-selection" }, { children: [_jsxs("span", __assign({ className: "mdl-selection-count" }, { children: [selectedRows.length, " selected"] })), _jsx(Button, { label: "Export selected", icon: "pi pi-file-excel", className: "mdl-selection-btn", onClick: function () {
                                var exportData = selectedRows.map(function (v, idx) { return ({
                                    'S.No': idx + 1,
                                    'Name': v.name,
                                    'Name (Tamil)': v.nameTamil,
                                }); });
                                var ws = XLSX.utils.json_to_sheet(exportData);
                                var wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, ws, 'Villages');
                                var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                                saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'villages-selected.xlsx');
                            } }), _jsx(Button, { label: "Delete selected", icon: "pi pi-trash", className: "mdl-selection-btn danger", onClick: handleBulkDelete })] }))) : (_jsxs(_Fragment, { children: [_jsxs("span", __assign({ className: "p-input-icon-left mdl-search" }, { children: [_jsx("i", { className: "pi pi-search" }), _jsx(InputText, { placeholder: "Search name or Tamil name", value: searchInput, onChange: function (e) { return setSearchInput(e.target.value); }, className: "mdl-search-input" })] })), _jsx(MultiSelect, { value: visibleColumns, options: allColumns, onChange: function (e) { return setVisibleColumns(e.value); }, optionLabel: "header", optionValue: "field", placeholder: "Columns", selectedItemsLabel: "Columns", maxSelectedLabels: 0, className: "mdl-columns-wrapper mdl-columns-multiselect" })] })) })), _jsxs(DataTable, __assign({ value: tableValue, selectionMode: "checkbox", selection: selectedRows, onSelectionChange: function (e) { return setSelectedRows(e.value); }, dataKey: "id", paginator: true, first: first, rows: rows, onPage: function (e) { setFirst(e.first); setRows(e.rows); }, removableSort: true, className: "p-datatable-sm mdl-table-header mdl-table-footer", paginatorLeft: _jsxs("div", __assign({ className: "mdl-footer-left" }, { children: [_jsxs("span", __assign({ className: "mdl-footer-count" }, { children: ["Showing ", _jsx("b", { children: filteredVillages.length === 0 ? 0 : first + 1 }), " to ", _jsx("b", { children: Math.min(first + rows, filteredVillages.length) }), " of ", filteredVillages.length] })), _jsxs("span", __assign({ className: "mdl-footer-rpp" }, { children: [_jsx("label", __assign({ htmlFor: "village-rows-per-page" }, { children: "Rows per page" })), _jsx(Dropdown, { inputId: "village-rows-per-page", value: rows, options: [12, 25, 50], onChange: function (e) { setRows(e.value); setFirst(0); }, className: "mdl-rows-dropdown" })] }))] })), paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink", emptyMessage: globalFilter ? 'No villages match your filters' : 'No villages yet' }, { children: [_jsx(Column, { selectionMode: "multiple", headerStyle: { width: '44px' }, style: { width: '44px' } }), visibleColumns.includes('sno') && _jsx(Column, { field: "sno", header: "S.No", body: serialNumberTemplate, headerClassName: "mdl-col-numeric", bodyClassName: "mdl-col-numeric", style: { width: '72px' }, sortable: true }), visibleColumns.includes('name') && _jsx(Column, { field: "name", header: "Name", body: nameBodyTemplate, style: { width: '240px' }, sortable: true }), visibleColumns.includes('nameTamil') && _jsx(Column, { field: "nameTamil", header: "Name (Tamil)", body: nameTamilBodyTemplate, sortable: true }), _jsx(Column, { header: "Action", body: actionBodyTemplate, headerClassName: "mdl-col-numeric", style: { width: '150px' } })] })), _jsxs(Dialog, __assign({ visible: dialogVisible, onHide: function () { return setDialogVisible(false); }, header: selectedVillage ? 'Edit Village' : 'Add Village', modal: true, className: "p-fluid", footer: _jsxs("div", { children: [_jsx(Button, { label: "Cancel", icon: "pi pi-times", onClick: function () { return setDialogVisible(false); }, className: "p-button-text" }), _jsx(Button, { label: "Save", icon: "pi pi-check", onClick: handleSave, className: "p-button-primary" })] }) }, { children: [_jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "name" }, { children: "Name *" })), _jsx(InputText, { id: "name", value: (selectedVillage === null || selectedVillage === void 0 ? void 0 : selectedVillage.name) || newVillage.name, onChange: function (e) {
                                    if (selectedVillage) {
                                        setSelectedVillage(__assign(__assign({}, selectedVillage), { name: e.target.value }));
                                    }
                                    else {
                                        setNewVillage(__assign(__assign({}, newVillage), { name: e.target.value }));
                                    }
                                }, required: true, className: "w-full" })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "nameTamil" }, { children: "Name (Tamil) *" })), _jsx(InputText, { id: "nameTamil", value: ((_a = selectedVillage === null || selectedVillage === void 0 ? void 0 : selectedVillage.nameTamil) !== null && _a !== void 0 ? _a : newVillage.nameTamil) || '', onChange: function (e) {
                                    if (selectedVillage) {
                                        setSelectedVillage(__assign(__assign({}, selectedVillage), { nameTamil: e.target.value }));
                                    }
                                    else {
                                        setNewVillage(__assign(__assign({}, newVillage), { nameTamil: e.target.value }));
                                    }
                                }, required: true, className: "w-full" })] }))] })), _jsx(Dialog, __assign({ visible: viewDialogVisible, onHide: function () { return setViewDialogVisible(false); }, header: "View Village Details", modal: true, className: "p-fluid", style: { width: '40vw' }, closeOnEscape: true, footer: _jsx("div", { children: _jsx(Button, { label: "Close", icon: "pi pi-times", onClick: function () { return setViewDialogVisible(false); }, className: "p-button-text" }) }) }, { children: selectedVillage && (_jsxs("div", __assign({ className: "grid" }, { children: [_jsx("div", __assign({ className: "col-12" }, { children: _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ className: "font-bold" }, { children: "Name:" })), _jsx("div", __assign({ className: "p-2 bg-gray-100 rounded" }, { children: selectedVillage.name }))] })) })), _jsx("div", __assign({ className: "col-12" }, { children: _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ className: "font-bold" }, { children: "Name (Tamil):" })), _jsx("div", __assign({ className: "p-2 bg-gray-100 rounded" }, { children: selectedVillage.nameTamil }))] })) }))] }))) }))] })));
};
export default Village;
